import React, { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import FormSection from "./FormSection";
import StatusChip from "./StatusChip";
import { REQUEST_HISTORY } from "../constants";
import { toHistoryRows } from "../requestHistory";
import useAssistedAffiliationStyles from "../styles";
import type { AssistedAffiliationStatus, RequestHistoryProps } from "../types";

// Solo lectura: muestra lo que trae la consulta de la solicitud. Un cambio de estado aparece aquí
// cuando el guardado sale bien y la pantalla vuelve a consultar la solicitud.
const RequestHistory = ({ id, observations }: RequestHistoryProps) => {
  const classes = useAssistedAffiliationStyles();
  const rows = useMemo(() => toHistoryRows(observations), [observations]);
  const hasRows = rows.length > 0;

  return (
    <FormSection
      id={id}
      title={REQUEST_HISTORY.title}
      subtitle={hasRows ? REQUEST_HISTORY.subtitle : undefined}
    >
      {hasRows ? (
        <TableContainer>
          <Table size="small" aria-label={REQUEST_HISTORY.title} className={classes.historyTable}>
            <TableHead>
              <TableRow className={classes.historyHeadRow}>
                <TableCell>{REQUEST_HISTORY.columns.date}</TableCell>
                <TableCell>{REQUEST_HISTORY.columns.status}</TableCell>
                <TableCell>{REQUEST_HISTORY.columns.reason}</TableCell>
                <TableCell>{REQUEST_HISTORY.columns.user}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.key}>
                  <TableCell className={classes.historyDate}>{row.date}</TableCell>
                  <TableCell>
                    <StatusChip status={row.status as AssistedAffiliationStatus} />
                  </TableCell>
                  <TableCell className={classes.historyReason}>{row.reason}</TableCell>
                  <TableCell className={classes.historyUser}>{row.user}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body2" color="textSecondary">
          {REQUEST_HISTORY.empty}
        </Typography>
      )}
    </FormSection>
  );
};

export default RequestHistory;
